import actions from './actions';
import mutations from './mutations';

const state = {
  stats: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
